<template>
  <div style="padding-bottom: 80px;">

    <!-- toolbar container, to prevent parent flexer shrinking children like hlines -->
    <div>
      <v-container pa-4 style="position: relative;">
        <!-- PC TOOLBAR -->
        <div v-if="!$vuetify.breakpoint.xs" class="mt-4 pa-4">

          <v-layout align-center>
            <div class="headline mt-4">
              Production
            </div>
          </v-layout>

        </div>

        <v-tabs v-model="activeTab" background-color="foreground">
          <v-tab>Qued</v-tab>
          <v-tab>In process</v-tab>
          <v-tab>Complete</v-tab>
        </v-tabs>

      </v-container>
    </div>
    <!-- end toolbar container, to prevent parent flexer shrinking children linke hlines -->

    <!-- MAIN CONTENT -->
    <div style="overflow: auto;">
      <v-container pa-4>
        <qued-productions v-if="activeTab === 0"></qued-productions>
        <productions-in-process v-if="activeTab === 1"></productions-in-process>
        <complete-productions v-if="activeTab === 2"></complete-productions>
      </v-container>
    </div>

  </div>
</template>

<script>
import QuedProductions from './ProductionListQued'
import CompleteProductions from './ProductionListComplete'
import ProductionsInProcess from './ProductionListInProcess'

export default {
  name: 'productions',
  components: {
    QuedProductions,
    CompleteProductions,
    ProductionsInProcess
  },
  data () {
    return {
      activeTab: 0
    }
  },
  computed: {
    drawer: {
      get () {
        return this.$store.state.navMain
      },
      set (val) {
        this.$store.commit('openNavMain', val)
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>

